module.exports = __webpack_public_path__ + "img/f661c33.jpg";